import dynamic from 'next/dynamic';

import AskForAvailabilityLoader from './components/AskForAvailabilityLoader';

const AskForAvailability = dynamic(() => import('./AskForAvailability.container'), {
  ssr: false,
  loading: () => <AskForAvailabilityLoader />,
});

export { default as classes } from './AskForAvailability.module.scss';
export type { AskForAvailabilityValues } from './AskForAvailability.types';

export default AskForAvailability;
